export default __webpack_public_path__ + "static/media/exitNavbarIcon.1f823b59.svg";